import get from 'lodash/get';

import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import smTypes from './types';
import {
  defaultArr,
  defaultObj,
  defaultList
} from './utils';
import enhancementsReducer from '../Enhancements/reducer';
import productReducer from './features/product/reducer';
import documentReducer from './features/documents/reducer';
import certificationReducer from './features/certifications/reducer';
import factoryReducer from './features/factory/reducer';
import factoryDocumentReducer from './features/factoryDocuments/reducer';
import factorySupplierReducer from './features/factorySupplier/reducer';
import factoryCertificationReducer from './features/factoryCertifications/reducer';

const initialState = {
  // Supplier
  smSupplierDetail: {
    ...defaultObj,
  },
  smLocations: {
    ...defaultArr,
  },
  smProvinces: {
    ...defaultArr,
  },
  smCities: {
    ...defaultArr,
  },
  smTags: {
    ...defaultArr,
  },
  smSupplierInternalNotes: {
    ...defaultArr,
  },
  certificationTypes: {
    ...defaultArr,
  },
  createSMTag: {
    ...defaultObj,
  },
  createSMSupplier: {
    ...defaultObj,
  },
  smSupplierList: {
    ...defaultList,
    quantity: 0,
  },
  smFactoryList: {
    ...defaultList,
    quantity: 0,
  },
  updateSMSupplierProfile: {
    ...defaultObj,
  },
  updateSMSupplierCategory: {
    ...defaultObj,
  },
  updateSMSupplierTag: {
    ...defaultObj,
  },
  updateSMSupplierRating: {
    ...defaultObj,
  },
  smSupplierFactoryList: {
    ...defaultList,
  },
  // Factory
  smFactoryDetail: {
    ...defaultObj,
  },
  createSMFactory: {
    ...defaultObj,
  },
  productTab: {
    ...defaultList,
    sorter: {
      direction: 'asc',
      label: 'Date created',
      key: 'createdAt',
    },
  },
  documentTab: {
    ...defaultList,
  },
  certificationTab: {
    ...defaultList,
  },
  factoryTab: {
    ...defaultList,
  },
  factoryDocumentTab: {
    ...defaultList,
  },
  factoryCertificationTab: {
    ...defaultList,
  },
  factorySupplierTab: {
    ...defaultList,
  },
};

const Reducers = {
  enhancements: enhancementsReducer,
  product: productReducer,
  document: documentReducer,
  certification: certificationReducer,
  factory: factoryReducer,
  factorySupplier: factorySupplierReducer,
  factoryDocument: factoryDocumentReducer,
  factoryCertification: factoryCertificationReducer,
};

const Actions = [{
    actions: [
      'SELECT_SM_SUPPLIER',
      'UPDATE_SM_SUPPLIER_STATUS',
      'GET_SM_FACTORY_QUANTITY',
      'GET_SM_SUPPLIER_QUANTITY',
      'SM_SUPPLIER_LIST',
      'SM_FACTORY_LIST',
      'SM_SUPPLIER_QUANTITY',
      'SM_FACTORY_QUANTITY',
    ],
    key: 'enhancements',
  },
  {
    actions: [
      'GET_SM_PRODUCT_LIST',
      'UPDATE_SM_SEARCH_PRODUCT_LIST',
      'UPDATE_SM_PARAMS_PRODUCT_LIST',
    ],
    key: 'product',
  },
  {
    actions: ['GET_SM_DOCUMENTS', 'UPDATE_SM_DOCUMENTS_PARAMS'],
    key: 'document',
  },
  {
    actions: ['GET_SM_CERTIFICATIONS', 'UPDATE_SM_CERTIFICATIONS_PARAMS'],
    key: 'certification',
  },
  {
    actions: ['GET_SM_FACTORIES', 'UPDATE_SM_FACTORIES_PARAMS', 'UPDATE_SM_FACTORIES_SEARCH'],
    key: 'factory',
  },
  {
    actions: [
      'GET_SM_FACTORY_SUPPLIERS',
      'UPDATE_SM_FACTORY_SUPPLIERS_PARAMS',
      'UPDATE_SM_FACTORY_SUPPLIERS_SEARCH',
    ],
    key: 'factorySupplier',
  },
  {
    actions: ['GET_SM_FACTORY_DOCUMENTS', 'UPDATE_SM_FACTORY_DOCUMENTS_PARAMS'],
    key: 'factoryDocument',
  },
  {
    actions: ['GET_SM_FACTORY_CERTIFICATIONS', 'UPDATE_SM_FACTORY_CERTIFICATIONS_PARAMS'],
    key: 'factoryCertification',
  },
];

const getReducerByAction = (action) => {
  const keyReducer = Actions.reduce((acc, current) => {
    const wasFound = current.actions.some((actionKey) => action.type.includes(actionKey));
    if (wasFound) {
      return current.key;
    }
    return acc;
  }, '');
  return Reducers[keyReducer];
};
export default (state = initialState, action) => {
  const reducer = getReducerByAction(action);
  if (reducer) {
    return reducer(state, action);
  }
  switch (action.type) {
    case asyncActionTypeRequest(smTypes.GET_SM_SUPPLIER_DETAIL): {
      return {
        ...state,
        smSupplierDetail: {
          ...state.smSupplierDetail,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SM_SUPPLIER_DETAIL): {
      return {
        ...state,
        smSupplierDetail: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SM_SUPPLIER_DETAIL): {
      return {
        ...state,
        smSupplierDetail: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.CREATE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          ...state.smSupplierInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.CREATE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: [...state.smSupplierInternalNotes.data] || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.CREATE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          ...state.smSupplierInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.UPDATE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          ...state.smSupplierInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.UPDATE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: [...state.smSupplierInternalNotes.data] || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.UPDATE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.DELETE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          ...state.smSupplierInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.DELETE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: [...state.smSupplierInternalNotes.data] || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.DELETE_SUPPLIER_INTERNAL_NOTES): {
      return {
        ...state,
        smSupplierInternalNotes: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_SM_LOCATIONS): {
      return {
        ...state,
        smLocations: {
          ...state.smLocations,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SM_LOCATIONS): {
      return {
        ...state,
        smLocations: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SM_LOCATIONS): {
      return {
        ...state,
        smLocations: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_SM_PROVINCES): {
      return {
        ...state,
        smProvinces: {
          ...state.smProvinces,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SM_PROVINCES): {
      return {
        ...state,
        smProvinces: {
          loading: false,
          data: get(action, 'response') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SM_PROVINCES): {
      return {
        ...state,
        smProvinces: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_SM_CITIES): {
      return {
        ...state,
        smCities: {
          ...state.smCities,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SM_CITIES): {
      return {
        ...state,
        smCities: {
          loading: false,
          data: get(action, 'response') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SM_CITIES): {
      return {
        ...state,
        smCities: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_SM_TAGS): {
      return {
        ...state,
        smTags: {
          ...state.smTags,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SM_TAGS): {
      return {
        ...state,
        smTags: {
          loading: false,
          data: get(action, 'response') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SM_TAGS): {
      return {
        ...state,
        smTags: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_CERTIFICATION_TYPES): {
      return {
        ...state,
        certificationTypes: {
          ...state.certificationTypes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_CERTIFICATION_TYPES): {
      return {
        ...state,
        certificationTypes: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_CERTIFICATION_TYPES): {
      return {
        ...state,
        certificationTypes: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.CREATE_SM_TAG): {
      return {
        ...state,
        createSMTag: {
          ...state.createSMTag,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.CREATE_SM_TAG): {
      const newTag = get(action, 'response') || {};
      return {
        ...state,
        createSMTag: {
          loading: false,
          data: newTag,
          error: '',
        },
        smTags: {
          ...state.smTags,
          data: [...state.smTags.data, newTag],
        },
      };
    }
    case asyncActionTypeFailure(smTypes.CREATE_SM_TAG): {
      return {
        ...state,
        createSMTag: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.CREATE_SM_SUPPLIER): {
      return {
        ...state,
        createSMSupplier: {
          ...state.createSMSupplier,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.CREATE_SM_SUPPLIER): {
      return {
        ...state,
        createSMSupplier: {
          loading: false,
          data: get(action, 'response') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.CREATE_SM_SUPPLIER): {
      return {
        ...state,
        createSMSupplier: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.GET_SM_FACTORY_DETAIL): {
      return {
        ...state,
        smFactoryDetail: {
          ...state.smFactoryDetail,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.GET_SM_FACTORY_DETAIL): {
      return {
        ...state,
        smFactoryDetail: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.GET_SM_FACTORY_DETAIL): {
      return {
        ...state,
        smFactoryDetail: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(smTypes.CREATE_SM_FACTORY): {
      return {
        ...state,
        createSMFactory: {
          ...state.createSMFactory,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(smTypes.CREATE_SM_FACTORY): {
      return {
        ...state,
        createSMFactory: {
          loading: false,
          data: get(action, 'response') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(smTypes.CREATE_SM_FACTORY): {
      return {
        ...state,
        createSMFactory: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    default:
      return state;
  }
};